fromMasked = function(phone) {
    return phone.replaceAll('_', '').replaceAll('-', '');
}

$(function () {
    jQuery.validator.addMethod('maskedPhoneLength', function(value, element, param) {
        if (this.optional(element)) {
            return true;
        }

        const v = fromMasked(value);

        if (v.length < param.min) {
            return false;
        }

        if (v.length > param.max) {
            return false;
        }

        return true;
    }, $.validator.format("Vänligen kontrollera mobilnumret!"));
});

$(function () {
    jQuery.validator.addMethod('maskedLength', function(value, element, param) {
        return this.optional(element) || fromMasked(value).length === param;
    }, $.validator.format("Detta fält är obligatoriskt."));
});

$(function () {
    jQuery.validator.addMethod('personalIdCheck', function(value, element, param) {
        return this.optional(element) || personalIdCheckSum(fromMasked(value));
    }, $.validator.format("Ogiltig personnummer."));
});

registerValidator = function (form_id, rules) {
    $(form_id).validate({
        rules: rules,
        errorElement: 'div',
        errorClass: 'field-error-msg',
        errorPlacement: function (error, element) {
            if ($(element).attr('type') !== 'checkbox') {
                error.insertAfter(element);
            }
        },
        highlight: function (element, errorClass, validClass) {
            if ($(element).attr('type') === 'checkbox') {
                $(element).closest('.check-block').addClass('error');
            } else {
                $(element).addClass('error');
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            if ($(element).attr('type') === 'checkbox') {
                $(element).closest('.check-block').removeClass('error');
            } else {
                $(element).removeClass('error');
            }
        },
        submitHandler: function (form) {
            $('.primary-btn').addClass('disabled');
            form.submit();
        },
        invalidHandler: function(form, validator) {
            if (!validator.numberOfInvalids())
                return;

            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).offset().top
            }, 2000);
        }
    });
}
